import { DiscoBall as DiscoBallSvg } from '@eventbrite/eds-iconography';
import { useIsMobileDevice } from '@eventbrite/feature-detection';
import { gettext } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { NIGHTLIFE_TOUCHPOINT_CLICK_EVENT } from '../../experimentation/constants';
import styles from './NightlifeTouchpoint.module.scss';
import { buttonData } from './touchpointConstants';

interface DetailsProps {
    isMobile: boolean;
}

interface ActionsProps {
    slug?: string;
}

export const NightlifeTouchpoint = (props: { slug: string }) => {
    const { slug } = props;
    const isMobile = useIsMobileDevice();

    return (
        <div className={styles.touchpointCardDiv}>
            <div className={styles.touchpoint}>
                <Details isMobile={isMobile} />
                <Actions slug={slug} />
            </div>
        </div>
    );
};

const Details = ({ isMobile }: DetailsProps) => {
    const touchpointTitleDesktop = gettext('Live your best nightlife');
    const touchpointTitleMobile = gettext('Explore nightlife');
    const touchpointSubTitle = gettext(
        'Discover the best things to do after dark near you.',
    );
    return (
        <div className={styles.details}>
            <div className={styles.icon}>
                <DiscoBallSvg />
            </div>
            <div className={styles.detailText}>
                <Typography variant="heading-sm" className={styles.title}>
                    {isMobile ? touchpointTitleMobile : touchpointTitleDesktop}
                </Typography>
                <Typography variant="body-md" className={styles.description}>
                    {touchpointSubTitle}
                </Typography>
            </div>
        </div>
    );
};

const Actions = ({ slug }: ActionsProps) => {
    const handleOnClick = (statsigEvent: string) => {
        logEvent(NIGHTLIFE_TOUCHPOINT_CLICK_EVENT);
        logEvent(statsigEvent);
    };

    return (
        <div className={styles.actions}>
            {buttonData.map((button, index) => (
                <a
                    className={styles.button}
                    key={index}
                    data-heap-id="NL-touchpoint-citybrowse"
                    onClick={() => handleOnClick(button.statsigEvent)}
                    href={`/b/${slug}/nightlife/?category=${button.link}`}
                >
                    <Typography variant="body-md-bold">
                        {button.text}
                    </Typography>
                </a>
            ))}
        </div>
    );
};

export default NightlifeTouchpoint;
